import { types } from "../types/types";

export const updateUploadProgress = (progress) => {
    return {
        type: types.UPDATE_UPLOAD_PROGRESS,
        payload: progress,
    };
};